import { axios } from '../request'

// Vuex module backing the Pronobis import-status banner and details panel.
//
// The backend stores a single row summarising the latest Pronobis Excel
// import: how many rows had unparseable value cells, which rows, and
// whether an admin has dismissed the resulting banner. This store mirrors
// that row and exposes a "visible" getter that drives the global banner
// in Notifications.vue.
export default (_app) => {
  return {
    namespaced: true,
    state: {
      lastSyncAt: null,
      parseErrorCount: 0,
      parseErrors: [],
      unresolvedCount: 0,
      unresolvedRows: [],
      dismissed: false,
      loaded: false,
    },
    mutations: {
      set(state, payload) {
        state.lastSyncAt = payload.lastSyncAt || null
        state.parseErrorCount = payload.parseErrorCount || 0
        state.parseErrors = Array.isArray(payload.parseErrors) ? payload.parseErrors : []
        state.unresolvedCount = payload.unresolvedCount || 0
        state.unresolvedRows = Array.isArray(payload.unresolvedRows) ? payload.unresolvedRows : []
        state.dismissed = !!payload.dismissed
        state.loaded = true
      },
      markDismissed(state) {
        state.dismissed = true
      },
    },
    getters: {
      visible(state) {
        return (state.parseErrorCount || 0) + (state.unresolvedCount || 0) > 0 && !state.dismissed
      },
    },
    actions: {
      async fetch({ commit }) {
        try {
          const res = await axios.get('pronobis_transactions/import_status')
          commit('set', res.data?.data || {})
        } catch {
          // Non-pronobis orgs return 404; stay silent so the store ends up
          // in a zero-value loaded state and the banner stays hidden.
          commit('set', {})
        }
      },
      async dismiss({ commit }) {
        try {
          await axios.post('pronobis_transactions/import_status/dismiss')
          commit('markDismissed')
        } catch {
          // Dismiss failed (network error, server error) — banner stays
          // visible, which is the safe default. No user-facing noise.
        }
      },
      // Called by websocket.js when the backend broadcasts a fresh import
      // summary. Payload shape:
      // {count, errors, unresolvedCount, unresolved, dismissed}.
      handleParseErrorsEvent({ commit, state }, payload) {
        commit('set', {
          lastSyncAt: state.lastSyncAt,
          parseErrorCount: payload.count || 0,
          parseErrors: Array.isArray(payload.errors) ? payload.errors : [],
          unresolvedCount: payload.unresolvedCount || 0,
          unresolvedRows: Array.isArray(payload.unresolved) ? payload.unresolved : [],
          dismissed: !!payload.dismissed,
        })
      },
      // Called by websocket.js when another admin dismisses the banner.
      handleDismissedEvent({ commit }) {
        commit('markDismissed')
      },
    },
  }
}
